((Drupal) => {
  function getColumnsCount() {
    const width = window.innerWidth;
    if (width >= 992) return 4; // lg
    if (width >= 768) return 3; // md
    if (width >= 576) return 2; // sm
    return 1;                   // xs
  }

  function regroupItems(grid) {
    const columns = getColumnsCount();

    // Unwrap all existing groups back to flat items
    const existingGroups = Array.from(grid.querySelectorAll('.tag-grid__row-group'));
    existingGroups.forEach((group) => {
      while (group.firstChild) {
        grid.insertBefore(group.firstChild, group);
      }
      group.remove();
    });

    // Re-group based on current column count
    const items = Array.from(grid.querySelectorAll('.views-row'));
    for (let i = 0; i < items.length; i += columns) {
      const group = document.createElement('div');
      group.className = 'tag-grid__row-group';

      const chunk = items.slice(i, i + columns);
      chunk[0].parentNode.insertBefore(group, chunk[0]);
      chunk.forEach((item) => group.appendChild(item));
    }
  }

  Drupal.behaviors.tagGrid = {
    attach(context) {
      const grids = once('tag-grid', '.tag-grid__items', context);

      grids.forEach((grid) => {
        const items = Array.from(grid.querySelectorAll('.views-row'));
        if (!items.length) return;

        // Initial grouping
        regroupItems(grid);

        // Regroup on resize
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => regroupItems(grid), 100);
        });
      });
    },
  };
})(Drupal);
